module.exports = {"TXTWCL_Converted_Limit":{"id":"TXTWCL_Converted_Limit","defaultMessage":"換算後の限度額"}}